// When the window is loaded....
window.addEventListener("load", function () {
	var swiper = new Swiper(".featured-products-swiper", {
		// Default parameters
		direction: "horizontal",
		threshold: 10,
		centerInsufficientSlides: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		slidesPerView: 2,
		spaceBetween: 16,
		// Responsive breakpoints
		breakpoints: {
			// when window width is <= 499px
			499: {
				slidesPerView: 1,
				spaceBetweenSlides: 10,
			},
			// when window width is <= 999px
			999: {
				slidesPerView: 4,
				spaceBetweenSlides: 40,
			},
		},
	});
});
